import { render, staticRenderFns } from "./CustomerCustomerOrder.vue?vue&type=template&id=37d28ad6&scoped=true"
import script from "./CustomerCustomerOrder.vue?vue&type=script&lang=js"
export * from "./CustomerCustomerOrder.vue?vue&type=script&lang=js"
import style0 from "./CustomerCustomerOrder.vue?vue&type=style&index=0&id=37d28ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d28ad6",
  null
  
)

export default component.exports